module.exports = __webpack_public_path__ + "img/huawei_runtime_fastgame.a3b775fe.png";